import {IObservableValue, observable} from "mobx";
import {LanguageApi} from "../api"
import {MLanguageCategory} from "@elte/translate-backend/interface/lang_category";


export type TCategoryLanguage = {
    main: MLanguageCategory.DataLanguageCategory[],
    target: MLanguageCategory.DataLanguageCategory[]
}

export class LanguageModel {

    private api: LanguageApi;


    constructor() {
        this.api = new LanguageApi()
    }

    dataCategory: IObservableValue<TCategoryLanguage> = observable.box(null);

    getLanguageCategory() {
        return this.api.find().then(value => {

            this.dataCategory.set({
                main: value,
                target: value,
            });

            return value
        });
    }


}
